import { h } from "vue";

export const ChartBarIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
      },
      [
        h("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z",
        }),
      ],
    ),
};

export const CubeTransparentIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
      },
      [
        h("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9",
        }),
      ],
    ),
};

export const ShieldCheckIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
      },
      [
        h("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z",
        }),
      ],
    ),
};

export const CloudArrowUpIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
      },
      [
        h("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12 16.5l4-4m0 0l-4-4m4 4H3m13.5 4.5V4a1.5 1.5 0 113 0v12.5M19.5 19.5h-15a2.25 2.25 0 01-2.25-2.25V6.75A2.25 2.25 0 014.5 4.5h15a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25z",
        }),
      ],
    ),
};

export const DevicePhoneMobileIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
      },
      [
        h("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3",
        }),
      ],
    ),
};

export const ArrowPathIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
      },
      [
        h("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99",
        }),
      ],
    ),
};

// Brigadeiro/trufa embrulhado, com espiral e pregas do papel — usado para
// segmentos de doces e alimentos. As linhas internas são cor de fundo (gray-100,
// o fundo da grade de segmentos) em vez de currentColor — é um recorte visual,
// não muda com a cor do ícone.
export const CandyIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
      },
      [
        h("path", { d: "M12 3C8 3 5 6 5 10L4 17C4 20 7 22 12 22C17 22 20 20 20 17L19 10C19 6 16 3 12 3Z" }),
        h("path", { d: "M4.3 15C7 16.5 17 16.5 19.7 15", stroke: "#f3f4f6", "stroke-width": "1.1", fill: "none", "stroke-linecap": "round" }),
        h("path", { d: "M5.3 10.5C8 12 16 12 18.7 10.5", stroke: "#f3f4f6", "stroke-width": "1.1", fill: "none", "stroke-linecap": "round" }),
        h("path", { d: "M12 5.2c-2 0-3.2 1.4-3.2 3s1.2 2.6 2.6 2.6 2.2-1 2.2-2.2-.8-1.8-1.8-1.8-1.4.6-1.4 1.4", stroke: "#f3f4f6", "stroke-width": "1", fill: "none", "stroke-linecap": "round" }),
      ],
    ),
};

// Sapato feminino de salto, de perfil — usado para segmentos de calçados.
// Path do ícone "high-heel-fill" do Phosphor Icons (MIT, phosphoricons.com).
export const ShoeIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        fill: "currentColor",
      },
      [
        h("path", {
          d: "M32,144a95.28,95.28,0,0,1,37.53,7.67,4,4,0,0,1,2.47,3.7V192a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V148a4,4,0,0,1,4-4Zm199,12.19L180,144.71,69.66,34.34a8,8,0,0,0-11.56.26C36.11,58.64,24,89,24,120a8,8,0,0,0,8,8,111.2,111.2,0,0,1,63.34,19.7,112.45,112.45,0,0,1,40.55,50.39A15.9,15.9,0,0,0,150.72,208H240a16,16,0,0,0,16-16v-4.73A31.72,31.72,0,0,0,231,156.19Z",
        }),
      ],
    ),
};

// Anel de noivado (aro + pedra) — usado para segmentos de bijuterias e joalherias.
// Path do ícone "ring" do Material Design Icons (Apache 2.0, materialdesignicons.com).
export const RingIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
      },
      [
        h("path", {
          d: "M12,10L8,4.4L9.6,2H14.4L16,4.4L12,10M15.5,6.8L14.3,8.5C16.5,9.4 18,11.5 18,14A6,6 0 0,1 12,20A6,6 0 0,1 6,14C6,11.5 7.5,9.4 9.7,8.5L8.5,6.8C5.8,8.1 4,10.8 4,14A8,8 0 0,0 12,22A8,8 0 0,0 20,14C20,10.8 18.2,8.1 15.5,6.8Z",
        }),
      ],
    ),
};

// Frasco de perfume — usado para segmentos de cosméticos e perfumarias.
export const PerfumeIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
      },
      [
        h("rect", { x: "9.5", y: "3", width: "5", height: "3", rx: "1" }),
        h("rect", { x: "10.3", y: "6", width: "3.4", height: "2.5" }),
        h("path", { d: "M8.5 8.5h7c.6 0 1 .4 1 1v10c0 1.7-1.3 3-3 3h-3c-1.7 0-3-1.3-3-3v-10c0-.6.4-1 1-1z" }),
      ],
    ),
};

// Cenoura com folhas — usado para segmentos de horti-fruti e verdureira.
export const CarrotsIcon = {
  render: () =>
    h(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
      },
      [
        h("path", { d: "M9.3 9L14.7 9L12 22.3Z" }),
        h("path", { d: "M9.5 8.2C8.4 7.6 7.4 4.7 8.3 1.2C9.7 3.8 10.6 5.9 11.3 8Z" }),
        h("path", { d: "M12 8.1C11.6 5.4 12 0.7 13.7 -2.2C14.3 1.2 13.8 5.4 13.2 7.9Z" }),
        h("path", { d: "M14.5 8C15.6 7.4 17.4 4.9 17.1 1.4C15.3 3.6 13.9 5.9 13.3 7.8Z" }),
      ],
    ),
};
